module.exports = __webpack_public_path__ + "img/video8.95374cef.jpg";